import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import {Provider} from 'react-redux';
import {store} from './store/store';
import  ThemeContext  from "./context/ThemeContext"; 
import { FeeProvider } from './context/FeeContext';
import { DataProvider } from './context/DataContext';
import { AcademicProvider } from './context/AcademicContext';
import { StudentsProvider } from './context/StudentsContext';
import { GradeProvider } from './context/GradeContext';
import { SfbProvider } from './context/SfbContext';
import { SubjectProvider } from './context/SubjectContext';
import { SBSCProvider } from './context/SbscContext';
import { SpinnerProvider } from './context/SpinnerContext';
import { CyamProvider } from './context/CyamContext';
import { AuthProvider } from './context/AuthContext';
import { NumberProvider } from './context/NumberContext';
import { StaffDataProvider } from './context/StaffsDataContext';
import { AssessmentProvider } from './context/AssessmentContext';
import { TcsDataProvider } from './context/TcsContext';
import { PaidListProvider } from './context/PaidListContext';
import { ARDataProvider } from './context/AttendanceRecordContext';
import { TCProvider } from './context/TCContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store = {store}>
      <BrowserRouter basename='/'>
        <ThemeContext>
          <DataProvider>
            <FeeProvider>
              <AcademicProvider>
                <StudentsProvider>
                  <GradeProvider>
                    <SfbProvider>
                      <SubjectProvider>
                        <SBSCProvider>
                          <SpinnerProvider>
                            <CyamProvider>
                            <AuthProvider>
                              <NumberProvider>
                                <StaffDataProvider>
                                  <AssessmentProvider>
                                    <TcsDataProvider>
                                      <PaidListProvider>
                                        <ARDataProvider>
                                          <TCProvider>
                                              <App />
                                          </TCProvider>                                         
                                        </ARDataProvider>
                                      </PaidListProvider>
                                    </TcsDataProvider>
                                  </AssessmentProvider>
                                </StaffDataProvider>                                
                              </NumberProvider>
                            </AuthProvider>                              
                            </CyamProvider>
                          </SpinnerProvider>
                        </SBSCProvider>
                      </SubjectProvider>
                    </SfbProvider>
                  </GradeProvider>
                </StudentsProvider>
              </AcademicProvider>
            </FeeProvider>
          </DataProvider>
        </ThemeContext>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();